// extracted by mini-css-extract-plugin
export var actionText = "_sc-4";
export var container = "_sc-0";
export var leftSection = "_sc-1";
export var rightSection = "_sc-2";
export var settingsButton = "_sc-6";
export var settingsIcon = "_sc-7";
export var shortcut = "_sc-5";
export var shortcutGroup = "_sc-3";